import Home from './Home';
import Blog from './Blog';
import Portfolio from './Portfolio';
import About from './About';
import Industry from './Industry';
import TOC from './Navigation';
import Contact from './Contact';
import Social from './SocialNav';
import { Route, Routes, Navigate } from 'react-router-dom';
import MetaTags from '../components/MetaTags';
import "./index.css";
export default function AlfonsBC() {
    return(
      <>
    <MetaTags
        title='Alfonso Barajas Cervantes'
        description='I help businesses minimize financial losses by detecting anomalies and forecasting trends in key performance indicators. Using the CRISP-DM methodology and advanced machine learning'
        />
      
    <div id="wd-app" className="App">
      <div className="flex-fill col-12">
        <div id="wd-toc" className="d-small-block">
        <TOC/>
        </div>
      </div>
      <div id="wd-app-content" className="col-12 h-100">
      <Routes>
        <Route path="/" element={<Navigate to="home"/> } />
        <Route path="/home" element={<Home/>} />
        <Route path="/industry/*" element={<Industry/>} />
        <Route path="/blog/*" element={<Blog/>} />
        <Route path="/about" element={<About/>} />
        <Route path="/portfolio/*" element={<Portfolio/>} />
        <Route path="/contact" element={<Contact/>} />
      </Routes>
      </div>
      <div id="wd-social-nav" className="flex-fill col-12">
      <Social/>
      </div>
    </div>
    </>
    );
}